import React, { useState, useEffect, useRef } from 'react';
import { Routes, Route } from 'react-router-dom';
import CreateLogComponent from '../createlog/CreateLogComponent.js';
import UserLogsTable from '../tables/UserLogsTable.js';
import Logo from '../../assets/logos/e-timer_logo2.png';
import WorkPlanner from './workplanner/WorkPlanner.js';
import ExportDialog from '../export/ExportDialog.js';
import Logout from '../logout/LogOut.js';
import MobileOverlay from './MobileOverlay.js';
import ThemeSwitcher from './utils/ThemeSwitcher.js';
import { useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { BlockUI } from 'primereact/blockui';
import Widget from './widget/Widget.js';
import { useSelector, useDispatch } from 'react-redux';
import {
  hideEldDialog,
  hideIntDialog,
  hideCtyDialog,
  hideLogDialog,
  hideOthDialog,
} from '../../redux/actions/dialogActions.js';
import {
  clearClient,
  clearComment,
  clearCty,
  clearLang,
  clearDate,
  clearEsp,
  clearHour,
  clearModType,
  clearModule,
  clearStage,
  clearTask,
  clearWorkingH,
  clearWpl,
  clearVersion,
} from '../../redux/actions/logActions.js';
import { fetchEldData, fetchInitialPosts, fetchEspPosts } from '../../redux/thunk/thunk.js';
import { fixDateLog } from './utils/utils.js';
import { dictionary } from '../../dictionary.js';
import packageJson from '../../../package.json';
import moment from 'moment';
const isDevelopment = process.env.NODE_ENV === 'development';
const API_URL = isDevelopment
  ? process.env.REACT_APP_API_URL
  : 'https://eld-timer-backend-service.api.prod.sit.sys.odj.cloud/';

const Content = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const eldData = useSelector((state) => state.fetch.data);
  const userPosts = useSelector((state) => state.posts.data);
  const espPosts = useSelector((state) => state.esps.data);
  const loggedUser = sessionStorage.getItem('userName');
  const admin = sessionStorage.getItem('user') ? JSON.parse(sessionStorage.getItem('user')).admin : null;
  const [disabled, setDisabled] = useState(false);
  const [widgetVisible, setWidgetVisible] = useState(false);
  const [formSubmitted, setFormSubbmited] = useState(false);
  const clientLog = useSelector((state) => state.client.value);
  const dateLog = new Date(useSelector((state) => state.date.value));
  const espLog = useSelector((state) => state.esp.value);
  const ctyLog = useSelector((state) => state.cty.value);
  const langLog = useSelector((state) => state.lang.value);
  const modTypeLog = useSelector((state) => state.modType.value);
  const stageLog = useSelector((state) => state.stage.value);
  const taskLog = useSelector((state) => state.task.value);
  const hourLog = useSelector((state) => state.hours.value);
  const wplLog = useSelector((state) => state.wpl.value);
  const commentLog = useSelector((state) => state.comment.value);
  const moduleLog = useSelector((state) => state.module.value);
  const versionLog = useSelector((state) => state.version.value);
  const [postEditing, setPostEditing] = useState(false);
  const [editId, setEditId] = useState(null);
  const widgetInfo = useSelector((state) => state.widget);
  const infoLength = widgetInfo ? widgetInfo.length : 0;
  const toast = useRef(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (loggedUser === null) {
      navigate('/home');
    }
  }, [loggedUser, navigate]);

  useEffect(() => {
    dispatch(fetchEldData());
    dispatch(fetchInitialPosts(loggedUser));
  }, [dispatch, loggedUser]);

  const checkIfDayIsPlanned = (day) => {
    let date = fixDateLog(day);
    let isPlanned = false;
    userPosts.forEach((post) => {
      if (post.date === date) {
        isPlanned = true;
      }
    });
    return isPlanned;
  };

  const showMsg = () => {
    toast.current.show({
      severity: 'warn',
      summary: dictionary.toast_summary_warn,
      detail: dictionary.toast_create_log_detail,
      life: 7000,
    });
  };

  const setValuesOnInitialState = () => {
    dispatch(clearDate());
    dispatch(clearClient());
    dispatch(clearModule());
    dispatch(clearCty());
    dispatch(clearLang());
    dispatch(clearModType());
    dispatch(clearStage());
    dispatch(clearTask());
    dispatch(clearHour());
    dispatch(clearComment());
    dispatch(clearEsp());
    dispatch(clearWpl());
    dispatch(clearWorkingH());
    setDisabled(false);
    setEditId(null);
    setPostEditing(false);
    setFormSubbmited(false);
    dispatch(hideEldDialog());
    dispatch(hideIntDialog());
    dispatch(hideCtyDialog());
    dispatch(hideLogDialog());
    dispatch(hideOthDialog());
    dispatch(clearVersion());
  };

  // ISO week number
  // https://en.wikipedia.org/wiki/ISO_week_date
  // https://momentjs.com/docs/#/get-set/iso-week/
  const getCw = (date) => {
    let dt = date.split('-');
    let dateStr = dt[1] + '/' + dt[2] + '/' + dt[0];
    let conv = new Date(dateStr);

    return moment(conv).isoWeek();
  };

  const onRowEditComplete = () => {
    setLoading(true);
    const formattedDate = fixDateLog(dateLog);

    let originalEntry = userPosts?.flatMap((day) => day.entries).find((entry) => entry._id === editId);
    if (!originalEntry && espPosts) {
      originalEntry = espPosts.flatMap((post) => post.entries).find((entry) => entry._id === editId);
    }

    if (!originalEntry) {
      console.error('No entry found to edit.');
      setLoading(false);
      return;
    }

    const originalUser = originalEntry.user;
    const isDateChanged = originalEntry.date !== formattedDate;

    let inheritedWpl = wplLog;
    let inheritedWorkingh = originalEntry.workingh;
    let existingEntries = [];

    if (originalUser === loggedUser) {
      const dayData = userPosts.find((day) => day.date === formattedDate);
      if (dayData && dayData.entries) {
        existingEntries = dayData.entries.filter((entry) => entry._id !== editId);
        if (isDateChanged && dayData.entries.length > 0) {
          inheritedWpl = dayData.entries[0].wpl;
          inheritedWorkingh = dayData.entries[0].workingh;
        }
      }
    }

    const log = {
      user: originalUser,
      client: clientLog.toUpperCase(),
      esp: espLog ?? '',
      country: ctyLog ?? '',
      ...(clientLog.toUpperCase() === 'ESP' && { lang: langLog ?? '' }),
      module_type: modTypeLog ?? '',
      module: moduleLog,
      stage: stageLog ?? '',
      task: taskLog ?? '',
      hours: hourLog,
      wpl: inheritedWpl,
      workingh: inheritedWorkingh,
      comment: commentLog ?? '',
      date: formattedDate,
      cw: getCw(formattedDate),
      ...(clientLog.toUpperCase() === 'ESP' && { version: versionLog ?? '1.0' }),
    };

    const updateMain = fetch(`${API_URL}posts/${editId}`, {
      method: 'PATCH',
      mode: 'cors',
      credentials: 'include',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(log),
    });

    const updateOthers =
      !isDateChanged && originalUser === loggedUser
        ? existingEntries
            .filter((entry) => entry.wpl !== wplLog)
            .map((entry) =>
              fetch(`${API_URL}posts/${entry._id}`, {
                method: 'PATCH',
                mode: 'cors',
                credentials: 'include',
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({ wpl: wplLog }),
              })
            )
        : [];

    Promise.all([updateMain, ...updateOthers])
      .then((responses) => {
        const allOk = responses.every((res) => res.ok);
        if (!allOk) throw new Error('Some entries could not be updated.');

        dispatch(fetchInitialPosts(contentProps.loggedUser));

        if (admin) {
          dispatch(fetchEspPosts());
        }
      })
      .catch((error) => {
        console.error('Error while updating entries', error);
      })
      .finally(() => {
        setLoading(false);
        setValuesOnInitialState();
      });
  };

  const contentProps = {
    userPosts: userPosts,
    loggedUser: loggedUser,
    eldData: eldData,
    sortLogsByDates: props.sortLogsByDates,
    postEditing: postEditing,
    disabled: disabled,
    formSubmitted: formSubmitted,
    checkIfDayIsPlanned: checkIfDayIsPlanned,
    showMsg: showMsg,
    setPostEditing: setPostEditing,
    getCw: getCw,
    onRowEditComplete: onRowEditComplete,
    setValuesOnInitialState: setValuesOnInitialState,
    setDisabled: setDisabled,
    setFormSubbmited: setFormSubbmited,
    setEditId: setEditId,
  };

  return (
    <div className="content-container">
      <MobileOverlay />
      <Toast ref={toast} className="toast-message" />
      <div className="content-left-bar">
        <div className="left-bar-menu">
          <div className="logo-wrapper">
            <img src={Logo} alt="app logo" />
          </div>
          <BlockUI blocked={loading}>
            <CreateLogComponent contentProps={contentProps} />
          </BlockUI>
          <h2>{dictionary.content_tools}</h2>
          <div className="workplanner-wrapper">
            <Button
              label={dictionary.work_planner_btn}
              icon="pi pi-calendar-plus"
              onClick={() => navigate('/timesheet/workplanner')}
            />
          </div>
          <div className="export-wrapper">
            <Button
              label={dictionary.export_btn}
              icon="pi pi-file-export"
              onClick={() => navigate('/timesheet/exportdata')}
            />
          </div>
          {admin ? (
            <div className="admin-wrapper">
              <Button icon="pi pi-cog" label={dictionary.admin_panel_btn} onClick={() => navigate('/adminpanel')} />
            </div>
          ) : null}
          <div className="logout-wrapper">
            <Button
              icon="pi pi-sign-out"
              label={dictionary.logout_btn_label}
              onClick={() => navigate('/timesheet/logout')}
            />
          </div>
          <div className="theme-wrapper">
            <ThemeSwitcher />
            <p id="app-version">v: {packageJson.version}</p>
          </div>
        </div>
      </div>
      <div className="content-table">
        <UserLogsTable contentProps={contentProps} />
        <div className="badge-wrapper">
          <Button icon="pi pi-bell p-overlay-badge" className="widget-btn" onClick={() => setWidgetVisible(true)}>
            <span className="p-badge">{infoLength}</span>
          </Button>
        </div>
        {widgetVisible ? (
          <Widget widgetInfo={widgetInfo} widgetVisible={widgetVisible} setWidgetVisible={setWidgetVisible} />
        ) : null}
      </div>
      <Routes>
        <Route path="workplanner" element={<WorkPlanner contentProps={contentProps} />} />
        <Route path="exportdata" element={<ExportDialog eldData={eldData} />} />
        <Route path="logout" element={<Logout />} />
      </Routes>
    </div>
  );
};

export default Content;
